module.exports = __webpack_public_path__ + "img/about-img.08e5f034.png";